import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FeedComponent } from './feed/components/feed/feed.component';
import { ChatComponent } from './chat/components/chat/chat.component';
import { UsersComponent } from './users/users.component';
import { SignOutComponent } from './sign-out/sign-out-container/sign-out.component';
import { DashboardComponent } from './dashboard/dashboard-container-component/dashboard.component';
import { AuthenticationGuard } from '../auth/guards/authentication.guard';
import { NotFoundComponent } from '../shared/components/not-found/not-found.component';
import { PublicProfileComponent } from './profile/components/public-profile/public-profile.component';
import { PrivateProfileComponent } from './profile/components/private-profile/private-profile.component';
import { EditProfileComponent } from './profile/components/edit-profile/edit-profile.component';

const routes: Routes = [
  { path: '', component: DashboardComponent },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthenticationGuard],
  },
  {
    path: 'feed',
    component: FeedComponent,
    canActivate: [AuthenticationGuard],
  },
  {
    path: 'chat/:id',
    component: ChatComponent,
    canActivate: [AuthenticationGuard],
  },
  {
    path: 'people',
    component: UsersComponent,
    canActivate: [AuthenticationGuard],
  },
  {
    path: 'profile',
    component: PrivateProfileComponent,
    canActivate: [AuthenticationGuard],
  },
  {
    path: 'user/:id',
    component: PublicProfileComponent,
    canActivate: [AuthenticationGuard],
  },
  {
    path: 'edit',
    component: EditProfileComponent,
    canActivate: [AuthenticationGuard],
  },
  { path: 'sign-out', component: SignOutComponent },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CoreRoutingModule {}
